module.exports = __webpack_public_path__ + "static/media/background404.ff84b8a5.png";